import { Vector3 } from "three";

// Shared movement scale for the Viewer and Create, independent of canvas size.
export function orbitNavigation(state, orbit) {
    state.theta -= orbit.deltaPhi * 0.005;
    state.phi -= orbit.deltaTheta * 0.005;
}

export function panNavigation(state, camera, pan) {
    const scale = state.projectionMode === "orthographic" ? state.orthographicSize : state.distance;
    const direction = new Vector3().subVectors(camera.position, state.target).normalize();
    const right = new Vector3().crossVectors(camera.up, direction).normalize();
    const up = new Vector3().crossVectors(direction, right).normalize();
    state.target.addScaledVector(right, -pan.deltaX * 0.002 * scale);
    state.target.addScaledVector(up, pan.deltaY * 0.002 * scale);
}

export function zoomNavigation(state, zoom) {
    if (state.projectionMode === "orthographic") {
        state.orthographicSize = Math.max(0.01, state.orthographicSize * Math.max(0.05, 1 + zoom.deltaZoom * 0.02));
    } else state.distance = Math.max(0.1, state.distance + zoom.deltaZoom * 0.02);
}
